module.exports = __webpack_public_path__ + "img/b1.f4111473.jpg";